import { textAlign, width } from "@mui/system";

const Applybtn = {
  border: '1px solid #00AFEF',
  boxShadow: '0px 0px 14px 0px #0000000F',
  padding: '7px',
  borderRadius: '10px',
  display: 'flex',// 👈 Add this line
};

export default Applybtn;

export const Continuebtn = {
  border: '1px solid #00AFEF',
  boxShadow: '0px 4px 4px 0px #0000000F',
  padding: '7px 9rem',
  borderRadius: '10px',
  color: '#FFFFFF',
  backgroundColor: '#00AFEF',
  display: 'flex',// 👈 Add this line
};
export const Ctnbtn = {
  border: '1px solid #00AFEF',
  boxShadow: ' 0px 4px 4px 0px #0000000F',
  // padding: '7px 20px',
  textAlign: 'center',
  width: '260px',
  borderRadius: '10px',
  color: '#FFFFFF',
  backgroundColor: '#00AFEF',

};
export const Newbtn = {
  border: '1px solid #00AFEF',
  padding: '9px 20px',
  textAlign: 'center',
  borderRadius: '10px',
  color: '#00AFEF',
  backgroundColor: '#FFFFFF',

};
export const Rejectbtn = {
  border: '1px solid #E00000',
  padding: '9px 80px',
  textAlign: 'center',
  borderRadius: '10px',
  color: '#E00000',
  backgroundColor: '#FFFFFF',

};
export const Acceptbtn = {
  border: '1px solid #00AFEF',
  boxShadow: '0px 4px 4px 0px #0000000F',
  padding: '9px 80px',
  borderRadius: '10px',
  color: '#FFFFFF',
  backgroundColor: '#00AFEF',
  display: 'flex',// 👈 Add this line
};
export const previewbtn = {
  border: '1px solid #00AFEF',
  boxShadow: ' 0px 4px 4px 0px #0000000F',
  textAlign: 'center',
  // width: '20px',
  borderRadius: '10px',
  color: '#00AFEF',
  backgroundColor: '#FFFFFF',

};
export const assetbtn = {
  textAlign: 'center',
  borderRadius: '10px',
  color: '#00AFEF',
  backgroundColor: '#EAF9FF',

};